import { env } from '../Env.js';
import { adjustHref } from './adjustHref.js';
import { getBasePath } from './getBasePath.js';
import { isURL } from './url.js';
export const adjustSrc = (router) => (src) => {
    const basePath = src?.startsWith('/wcms-resources') ? '' : getBasePath(env.SITE_URL);
    return src && !isURL(src) ? adjustHref(router)(src, basePath) : src;
};
//# sourceMappingURL=adjustSrc.js.map